import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {ItrentDebugService} from '../../../services/http/admin/itrent-debug.service';
import {DataService} from '../../../services/store/data.service';
import moment from 'moment';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

@Component({
  selector: 'app-debug-itrent-daily-patterns',
  templateUrl: './debug-itrent-daily-patterns.component.html',
  styleUrls: ['./debug-itrent-daily-patterns.component.less'],
  imports: [SHARED_IMPORTS]
})
export class DebugItrentDailyPatternsComponent implements OnInit {
  private itrentDebugService = inject(ItrentDebugService);
  private dataService = inject(DataService);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  employeeId: string;
  fromDate: string;
  toDate: string;
  rawDailyPatternResponse: string;

  /**
   * Set default data range which matches how data is being retrieved from iTrent in Backend.
   */
  ngOnInit(): void {
    this.fromDate = moment(this.dataService.rangeFrom).add(2, 'weeks').format('YYYY-MM-DD');
    this.toDate = moment(this.dataService.rangeTo).add(2, 'weeks').format('YYYY-MM-DD');
  }

  getRawResponseForDailyPatterns() {
    this.itrentDebugService.getRawResponseForDailyPatterns(this.employeeId, this.fromDate, this.toDate)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: response => this.rawDailyPatternResponse = response
            });
  }
}
